import { CircularProgress, Box, Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import Layout from "../components/Layout";
import { useAppSelector, useAppDispatch } from "../store";
import {
  selectIsAuthenticated,
  selectAuthLoading,
  selectUser,
} from "../store/selectors/authSelectors";
import { getCurrentUser } from "../store/slices/authSlice";

function ProtectedRoute(): React.ReactElement | null {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const { t } = useTranslation("common");
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const loading = useAppSelector(selectAuthLoading);

  if (loading && !user) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/auth"
        state={{ from: { pathname: location.pathname } }}
        replace
      />
    );
  }

  if (!user) {
    return (
      <Box sx={{ maxWidth: 560, mx: "auto", p: 3, mt: 6 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {t("session.unavailable")}
        </Alert>
        <Button
          variant="contained"
          onClick={(): void => {
            void dispatch(getCurrentUser());
          }}
        >
          {t("session.retry")}
        </Button>
      </Box>
    );
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export default ProtectedRoute;
